enum ClientStatus {
  ACTIVE = 'Active',
  HOSPITALIZED = 'Hospitalized',
  INCARCERATED = 'Incarcerated',
  DILIGENT_SEARCH = 'DiligentSearch',
  REHABILITATION = 'Rehabilitation',
  ACT_LITE = 'ActLite',
}

export default ClientStatus;
